import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdditionalInfoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9997 20.1666C16.0623 20.1666 20.1663 16.0625 20.1663 10.9999C20.1663 5.93731 16.0623 1.83325 10.9997 1.83325C5.93706 1.83325 1.83301 5.93731 1.83301 10.9999C1.83301 16.0625 5.93706 20.1666 10.9997 20.1666Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			className: "stroke"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8891 10.9999H7.11091",
			strokeWidth: 1.5,
			className: "stroke",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 7.11084V14.889",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			className: "stroke",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAdditionalInfoIcon;
